<div class="information">Authentication was successful</div>
